import React, { useMemo, useState } from 'react';
import { Link } from 'react-navi';
import { EntryCard, NavBar } from '@contest-web/components/src/components';
import { Helmet } from 'react-navi-helmet-async';

function Faq() {
  return (
    <div>
      <Helmet>
        <meta
          content={`【表彰式】注意事項・よくある質問 | ${process.env.REACT_APP_WEBSITE_NAME}`}
          property="og:title"
        />
        <meta content={`${process.env.REACT_APP_URL}/news/2019-11-11-faq`} property="og:url" />
      </Helmet>
      <div className="hero">
        <div className="hero-head">
          <NavBar logoImageSrc="/images/logo_black.svg" />
        </div>
      </div>
      <section className="section is-padding-bottom-0">
        <div className="container">
          <nav className="breadcrumb is-right is-small-mobile" aria-label="breadcrumbs">
            <ul className="is-align-center">
              <li>
                <Link className="has-text-primary" href="/top">
                  TOP
                </Link>
              </li>
              <li className="is-active">
                <Link href={`/news/2019-11-11-faq`} aria-current="page">
                  【表彰式】注意事項・よくある質問
                </Link>
              </li>
            </ul>
          </nav>
        </div>
      </section>
      <section className="section">
        <div className="container is-small">
          <div className="content">
            <h3>【表彰式】注意事項・よくある質問</h3>
            <div className="notification is-size-7">
              表彰式当日について、注意事項とよくある質問への回答をまとめました。
            </div>
            <ul>
              <li>
                <strong>当日投票はありません。</strong>
              </li>
              <li>
                <strong>ファイナリストへのプレゼント・差し入れについて</strong>
                <ul className="is-margin-left-0">
                  <li style={{ listStyle: 'none' }}>
                    コンテスト当日のみAGESTOCK2019のイベント受付にて、ファイナリストのプレゼント・差し入れを受付します。
                    <br />
                    受付時間は下記となりますため、必ず時間内にお持ち込み頂くようお願い申し上げます。
                    <br />
                    <p className="is-margin-top-1 is-margin-bottom-1">
                      <span className="tag is-primary is-light">プレゼント受付時間</span>
                      <span className="tag is-white">16:30(開場)〜19:00 チケットブースにて</span>
                    </p>
                  </li>
                  <li style={{ listStyle: 'none' }}>
                    受付時間外には受付し兼ねますので、必ず時間内に受付にお持ち込み頂きますようお願い申し上げます。
                  </li>
                  <li style={{ listStyle: 'none' }}>
                    17日に関しまして、MISS CIRCLE CONTEST 出場者へのプレゼントは受け付けておりません。FRESH CAMPUS
                    CONTEST 2019 ファイナリスト以外へのプレゼントはお受け取りし兼ねます。
                  </li>
                  <li style={{ listStyle: 'none' }}>
                    プレゼント・差し入れの内容物に関しては下記を注意事項をよくお読みください。
                  </li>
                  <li className="message is-size-7 is-warning is-margin-top-1" style={{ listStyle: 'none' }}>
                    <span className="message-header">【重要】プレゼント・差し入れについて注意事項</span>
                    <p className="message-body">
                      <h6>食品等のナマモノNG</h6>
                      <p>
                        花束を含む、飲食物・お菓子などのナマモノは衛生管理上NGとさせて頂きます。
                        <br />
                        花に関しては、「スタンド花」「楽屋花」のみお受け取り可能となっております。
                      </p>
                      <h6>中身を確認できないものNG</h6>
                      <p>
                        FRESH CAMPUS CONTEST
                        2019実行委員会により、本人に受け渡す前に中身を確認させていただく可能性がございます。
                        <br />
                        上記の注意事項に該当される物品だった場合、本人への受け渡しを差し控えさせて頂きます。
                        <br />
                        ご提出されたプレゼント・差し入れについてはいかなる場合でもご返却は致しません。予めご了承ください。
                      </p>
                    </p>
                  </li>
                </ul>
              </li>
                <li><strong>祝い花について</strong>
                    <ul className="is-margin-left-0">
                        <li style={{ listStyle: 'none' }}>本イベントにつきまして、業者の配送によるスタンド花を受け付けております。<br/>
                            楽屋にスタンド花の設置をご希望される場合、スペースの関係上「楽屋花」のみ設置を承っております。<br />
                            配送先等に関しては別途お問い合わせくださいませ。</li>
                    </ul>
                </li>
            </ul>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Faq;
